import { jsxs, jsx } from 'react/jsx-runtime';
import { mergeStyleSets, getScreenSelector, ScreenWidthMinXLarge, Dialog, NeutralColors, DialogType, Stack, Icon, DefaultPalette, Text, DialogFooter, PrimaryButton } from '@fluentui/react';
import { useTranslation } from 'react-i18next';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var styles = mergeStyleSets({
    dialog: _define_property({}, getScreenSelector(ScreenWidthMinXLarge, undefined), {
        minWidth: 512
    })
});
var ConfirmationModal = function(param) {
    var isOpen = param.isOpen, onDismiss = param.onDismiss;
    var t = useTranslation('header').t;
    var doneText = t('Done');
    var closeText = t('Close');
    var title = t('Thanks for your feedback');
    return /*#__PURE__*/ jsxs(Dialog, {
        styles: {
            main: {
                minHeight: 100
            }
        },
        maxWidth: 512,
        hidden: !isOpen,
        dialogContentProps: {
            className: styles.dialog,
            onDismiss: onDismiss,
            type: DialogType.close,
            closeButtonAriaLabel: closeText,
            title: title,
            titleProps: {
                color: NeutralColors.gray160
            },
            showCloseButton: true
        },
        children: [
            /*#__PURE__*/ jsxs(Stack, {
                grow: true,
                tokens: {
                    childrenGap: 8
                },
                horizontal: true,
                verticalAlign: "center",
                children: [
                    /*#__PURE__*/ jsx(Icon, {
                        styles: {
                            root: {
                                color: DefaultPalette.green
                            }
                        },
                        iconName: "Completed"
                    }),
                    /*#__PURE__*/ jsx(Text, {
                        children: t('Your insights will help us improve AppSource for everyone')
                    })
                ]
            }),
            /*#__PURE__*/ jsx(DialogFooter, {
                children: /*#__PURE__*/ jsx(PrimaryButton, {
                    onClick: onDismiss,
                    text: doneText
                })
            })
        ]
    });
};

export { ConfirmationModal as default };
